import { cn } from '@/lib/utils';

type FieldsetCardProps = { children: React.ReactNode; className?: string; overflown?: boolean };

const FieldsetCard = ({ children, className, overflown, ...props }: FieldsetCardProps) => (
  <div
    className={cn(
      'relative rounded-lg border border-stroke bg-background p-4',
      overflown && 'overflow-x-auto',
      className
    )}
    {...props}
  >
    {children}
  </div>
);

export default FieldsetCard;
